import { JobGroupRunLogs, privateApi } from 'services';

const fetchJobGroupRunLogs = (jobGroupId: string, page: number): Promise<JobGroupRunLogs> =>
    privateApi.get<JobGroupRunLogs>(`job-groups/${jobGroupId}/run-logs?page=${page}`);

export const JobGroupRunLogGateway = {
    fetchJobGroupRunLogs,
};
